/** «Статус» — отдельный раздел в Аналитике на сайдбаре (Алексей 24.09, AI185):
 *  не за выбранный период, а по каждому типу данных за его рекомендованный.
 *  Пикера периода здесь нет — период подписан на каждой панели. */
import React from 'react';
import { useT } from '@/contexts/I18nContext';
import { usePageTitle } from '@/contexts/PageHeaderContext';
import { useCurrentZone } from '@/hooks/useCurrentZone';
import { useZoneFeatures } from '@/hooks/useZoneFeatures';
import { BranchRequiredState } from '@/components/common/BranchRequiredState';
import AnalyticsStatusTab from './AnalyticsStatusTab';
import StatusAllPage from './StatusAllPage';
import { useAppState } from '@/app/appContext';

export default function StatusPage() {
  const { t } = useT();
  usePageTitle(t('status.title'), t('status.subtitle'));
  const { currentZone } = useCurrentZone();
  const zoneId = currentZone?.id ? String(currentZone.id) : '';
  const { features } = useZoneFeatures(zoneId || null);
  const { zone: { allBranches } } = useAppState();
  // Те же условия, что у вкладок Статистики: невключённое не показываем вовсе (AI184).
  const statusFeatures = {
    tasks: !!(features?.checklists?.enabled && features.checklists.has_content),
    speech: !!features?.speech?.enabled,
    reviews: !!features?.reviews?.enabled,
    visits: !!(features?.visits?.enabled && features.visits.has_content),
    receipts: !!(features?.receipts?.enabled && features.receipts.has_content),
  };
  // «Все филиалы» / группа филиалов (#1969) — сводный статус по филиалам вместо «выберите филиал».
  if (allBranches) return <StatusAllPage />;
  if (!zoneId) return <BranchRequiredState />;
  return (
    <div className="mx-auto max-w-6xl p-4 md:p-6">
      <AnalyticsStatusTab zoneId={zoneId} features={statusFeatures} />
    </div>
  );
}
